import { SAMPLE_REMINDERS } from "@/constants/compliance";

const Dot = () => (
  <span className="mx-8 inline-block w-2 h-2 rotate-45 bg-[#D96B43] shrink-0 self-center" />
);

export const EditorialMarquee = () => {
  const items = [...SAMPLE_REMINDERS, ...SAMPLE_REMINDERS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-[#1E2022] py-6 sm:py-8 -rotate-1 scale-[1.02]"
    >
      <div className="marquee-track flex w-max">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-display font-bold text-2xl sm:text-4xl tracking-tight text-[#FAF8F5] whitespace-nowrap">
              {item}
            </span>
            <Dot />
          </div>
        ))}
      </div>
    </div>
  );
};
